import { render, staticRenderFns } from "./CarriageTemplate.vue?vue&type=template&id=5be913f4&scoped=true"
import script from "./CarriageTemplate.vue?vue&type=script&lang=js"
export * from "./CarriageTemplate.vue?vue&type=script&lang=js"
import style0 from "./CarriageTemplate.vue?vue&type=style&index=0&id=5be913f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be913f4",
  null
  
)

export default component.exports